import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";
import {FILTER_ALL} from ".";

interface Props {
	tagList: {code: string; name: string}[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const TravelMemberComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const tmemberListData = dataStr.replaceAll("|", "").split("^");
	const tmemberList: {code: string; name: string}[] = [];
	for (let i = 0; i < tmemberListData.length; i += 2) {
		const code = tmemberListData[i];
		const name = tmemberListData[i + 1];
		tmemberList.push({code, name});
	}

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="tmemberListAll"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={JSON.stringify({code: FILTER_ALL, name: "전체"})}
				/>
				<label htmlFor="tmemberListAll">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{tmemberList.map((tmember, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`tmemberList${tmember.code}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.some(e => e.code === tmember.code)}
						value={JSON.stringify({...tmember})}
					/>
					<label htmlFor={`tmemberList${tmember.code}`}>
						<span>{tmember.name}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const TravelMember = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter TravelMember Error">
		<TravelMemberComponent {...props} />
	</ErrorBoundary>
);

export default TravelMember;
